import React from "react";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="howitworks-section" style={{ padding: "60px 20px", backgroundColor: "#f9f9f9" }}>
      <div className="container" style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div className="section-title text-center" style={{ marginBottom: "50px" }}>
          <h2>How Your Board Mate Actually Works</h2>
          <p style={{ maxWidth: "700px", margin: "10px auto 0" }}>
            Forget thick policy manuals. Instead, get direct access to research-enhanced expert guidance through our proven 3-step process.
          </p>
        </div>

        <div className="row" style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          {/* Step 1 */}
          <div className="col-md-4" style={{ flex: "1 1 300px" }}>
            <div className="step-box card shadow-lg" style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#fff" }}>
              <div
                className="step-number"
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",   // circle ka size
                  height: "50px",
                  borderRadius: "50%", // round shape
                  backgroundColor: "#2d5016",
                  color: "#fff",
                  margin: "0 auto 15px auto", // auto horizontal margin
                }}
              >
                1
              </div>

              <h4>Free Systems-Backed Assessment + Policy Template</h4>
              <p>
                Complete our intake template (10–15 min). Covers business challenges,
                organisational issues, personal decisions, or crisis situations. Choose a
                professional policy template from our library.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-md-4" style={{ flex: "1 1 300px" }}>
            <div className="step-box card shadow-lg" style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#fff" }}>
              <div
                className="step-number"
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",   // circle ka size
                  height: "50px",
                  borderRadius: "50%", // round shape
                  backgroundColor: "#2d5016",
                  color: "#fff",
                  margin: "0 auto 15px auto", // auto horizontal margin
                }}
              >
                2
              </div>
              <h4>Expert Diagnosis & Solution Preview + Template Delivery</h4>
              <ul style={{ textAlign: "left", paddingLeft: "20px", marginTop: "10px" }}>
                <li>Problem validation with systematic analysis</li>
                <li>Consequence analysis</li>
                <li>Solution preview & implementation guidance</li>
                <li>Professional governance template (ready-to-use)</li>
              </ul>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-md-4" style={{ flex: "1 1 300px" }}>
            <div className="step-box card shadow-lg" style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#fff" }}>
              <div
                className="step-number"
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",  
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "#2d5016",
                  color: "#fff",
                  margin: "0 auto 15px auto", 
                }}
              >
                3
              </div>
              <h4>Choose Your Support Level</h4>
              <ul style={{ textAlign: "left", paddingLeft: "20px", marginTop: "10px" }}>
                <li>Monthly Advisory Service ($97–167/month)</li>
                <li>Complete Solution Packages ($497–2997)</li>
                <li>One-off Consultations ($67–197)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="row" style={{ marginTop: "50px", display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          <div className="col-md-6" style={{ flex: "1 1 500px" }}>
            <div className="benefits-box card shadow-lg" style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#fff" }}>
              <h3>What You Get Back:</h3>
              <ul style={{ textAlign: "left", paddingLeft: "20px", marginTop: "10px" }}>
                <li>Research-enhanced problem diagnosis</li>
                <li>Professional governance template</li>
                <li>Practical crisis-tested solutions</li>
                <li>Plain English guidance</li>
                <li>Crisis-tested recommendations</li>
              </ul>
            </div>
          </div>

          <div className="col-md-6" style={{ flex: "1 1 500px" }}>
            <div className="benefits-box card shadow-lg" style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#fff" }}>
              <h3>Why This Works Better:</h3>
              <ul style={{ textAlign: "left", paddingLeft: "20px", marginTop: "10px" }}>
                <li>Start completely free</li>
                <li>Immediate professional template</li>
                <li>More comprehensive than traditional consulting</li>
                <li>Real-world advice for real constraints</li>
                <li>Flexible support options</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
